module.exports = __webpack_public_path__ + "static/media/results-tip-icon2.fb1f50e6.png";